export const SEARCH_ENTITY = 'document' as const;
